export default function tableDataQueryStringBuilder(tableDataParam) {
  let queryString = `currentPage=${tableDataParam.currentPage}&pageSize=${tableDataParam.pageSize}`;

  if (tableDataParam.onlyUnassigned) queryString += '&onlyUnassigned=true';

  if (tableDataParam.sorts?.length) {
    queryString += tableDataParam.sorts
      .map((s, i) => `&sorts[${i}].asc=${s.asc ? 'true' : 'false'}&sorts[${i}].column=${s.column}`)
      .join('');
  }

  if (tableDataParam.filters?.length) {
    queryString += tableDataParam.filters
      .map((f, i) =>
        f.selectedColumn.column.columnWrapper
          ? `&filters[${i}].fieldName=${f.selectedColumn.column.filterColumn}&filters[${i}].operator=${
              f.comparator
            }&filters[${i}].fieldValue=${f.value}&filters[${i}].fieldType=${
              f.selectedColumn.column.type
            }&filters[${i}].useOr=${f.selectedColumn.column.useOr ? 'true' : 'false'}&filters[${i}].columnWrapper=${
              f.selectedColumn.column.columnWrapper
            }`
          : `&filters[${i}].fieldName=${f.selectedColumn.column.filterColumn}&filters[${i}].operator=${
              f.comparator
            }&filters[${i}].fieldValue=${f.value}&filters[${i}].fieldType=${
              f.selectedColumn.column.type
            }&filters[${i}].useOr=${f.selectedColumn.column.useOr ? 'true' : 'false'}`,
      )
      .join('');
  }

  if (tableDataParam.quickFilters?.length) {
    queryString += tableDataParam.quickFilters
      .map((f, i) =>
        f.columnWrapper
          ? `&quickFilters[${i}].fieldName=${f.filterColumn}&quickFilters[${i}].operator=${
              f.operator
            }&quickFilters[${i}].fieldValue=${f.value}&quickFilters[${i}].fieldType=${f.type}&filters[${i}].useOr=${
              f.useOr ? 'true' : 'false'
            }&quickFilters[${i}].columnWrapper=${f.columnWrapper}`
          : `&quickFilters[${i}].fieldName=${f.filterColumn}&quickFilters[${i}].operator=${
              f.operator
            }&quickFilters[${i}].fieldValue=${f.value}&quickFilters[${i}].fieldType=${f.type}&filters[${i}].useOr=${
              f.useOr ? 'true' : 'false'
            }`,
      )
      .join('');
  }
  if (tableDataParam.advancedFilter) {
    queryString += `&advancedFilter.condition=${tableDataParam.advancedFilter.condition}`;
    queryString += '&UseAdvancedFilter=true';
    queryString += tableDataParam.advancedFilter.rules
      .map((f, i) =>
        f.selectedColumn.column.columnWrapper
          ? `&advancedFilter.rules[${i}].Id=${f.id}&advancedFilter.rules[${i}].Field=${f.selectedColumn.column.filterColumn}&advancedFilter.rules[${i}].Operator=${f.comparator}&advancedFilter.rules[${i}].Type=${f.selectedColumn.column.type}&advancedFilter.rules[${i}].Value=${f.value}&advancedFilter.rules[${i}].Wrapper=${f.selectedColumn.column.columnWrapper}`
          : `&advancedFilter.rules[${i}].Id=${f.id}&advancedFilter.rules[${i}].Field=${f.selectedColumn.column.filterColumn}&advancedFilter.rules[${i}].Operator=${f.comparator}&advancedFilter.rules[${i}].Type=${f.selectedColumn.column.type}&advancedFilter.rules[${i}].Value=${f.value}`,
      )
      .join('');
  }

  if (tableDataParam.establishmentId) {
    queryString += `&establishmentId=${tableDataParam.establishmentId}`;
  }

  if (tableDataParam.schoolYearId) {
    queryString += `&schoolYearId=${tableDataParam.schoolYearId}`;
  }

  if (tableDataParam.personId) {
    queryString += `&personId=${tableDataParam.personId}`;
  }

  if (tableDataParam.employeeId) {
    queryString += `&employeeId=${tableDataParam.employeeId}`;
  }
  if (tableDataParam.search) {
    queryString += `&search=${tableDataParam.search}`;
  }
  return queryString;
}
